import { render, staticRenderFns } from "./IconArrowBack.vue?vue&type=template&id=f535e97c&"
import script from "./IconArrowBack.vue?vue&type=script&lang=js&"
export * from "./IconArrowBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports